import cs from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import type { FC } from 'react';
import { Box, Container } from '@/DesignSystem/Component';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
import type { ITeacherSubscription } from '@/Module/Subscription/Model/DataModel';
const NAME_COLORS: Record<string, string> = {
  orange: 'text-orangeFive',
  pink: 'text-pinkFive',
  primary: 'text-blueFive'
};
interface ISubscriptionPageTeacherTizhoshan {
  data: ITeacherSubscription[];
}
const SubscriptionPageTeacher: FC<ISubscriptionPageTeacherTizhoshan> = ({
  data
}) => {
  return <Container data-sentry-element="Container" data-sentry-component="SubscriptionPageTeacher" data-sentry-source-file="SubscriptionPageTeacher.tsx">
      <div className="py-4 sm:py-12">
        <h2 className="mb-12 text-center text-4xl font-extrabold text-blueFive drop-shadow-lightBlue ">
          معلم‌های خفن آی‌نو
        </h2>
        <div className="flex flex-row flex-nowrap items-end gap-2 overflow-x-scroll pt-12 md:justify-center md:gap-4 md:overflow-x-hidden">
          {data.map(teacher => <div key={teacher.img}>
              <Box as={Link} href={teacher.url} color={teacher.color} className={cs('cursor-pointer  w-[132px] block rounded-full')}>
                <Image src={`${FILE_BROWSER_URL}/img/teacher/${teacher.img}.webp`} key={teacher.img} alt={teacher.img} className="mt-[-40px] h-[160px] w-[132px] rounded-b-[70px]" width={132} height={160} />
              </Box>
              <Link href={teacher.url} className={cs('text-[12px] md:text-sm flex font-bold mb-1 cursor-pointer mt-2 w-full justify-center', NAME_COLORS[teacher.color])}>
                <p>{teacher.name}</p>
              </Link>
              <span className={cs('text-sm flex w-full justify-center mx-auto mb-1 cursor-pointer ', NAME_COLORS[teacher.color])}>
                {teacher.grade}
              </span>
            </div>)}
        </div>
      </div>
    </Container>;
};
export default SubscriptionPageTeacher;